import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Terms.css';
import logo from './assets/logo.png';

function Terms() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="terms-page">
      <nav className="terms-nav">
        <div className="container">
          <div className="nav-content">
            <div className="logo">
              <Link to="/">
                <img src={logo} alt="LucidBlack" className="logo-image" />
              </Link>
            </div>
            <Link to="/" className="btn-text">
              Back to Home
            </Link>
          </div>
        </div>
      </nav>

      <div className="terms-container">
        <div className="container">
          <h1 className="terms-title">Terms and Conditions</h1>
          <p className="terms-update">Last Updated: October 27, 2025</p>

          <div className="terms-content">
            <section className="terms-section">
              <h2>1. Acceptance of Terms</h2>
              <p>
                Welcome to Lucid Black! By accessing or using the website lucidblack.io (the "Site") or applying for the
                Lucid Black Rewards Credit Card (the "Card"), you agree to be bound by these Terms and Conditions ("Terms")
                and our Privacy Policy. If you do not agree to these Terms, you may not access or use our services.
              </p>
            </section>

            <section className="terms-section">
              <h2>2. The Lucid Black Rewards Program</h2>
              <p>The Lucid Black Card is a financial product that offers a unique rewards program.</p>

              <h3>Rewards Earning</h3>
              <p>
                Cardholders earn points, miles, or cash back (the "Rewards") for making monthly payments on an approved,
                eligible Vehicle Loan as defined in your Cardholder Agreement. Rewards are not earned on the initial vehicle
                purchase or on standard credit card purchases unless explicitly stated in the Cardholder Agreement.
              </p>

              <h3>Rewards Rate</h3>
              <p>
                The specific rate at which Rewards are earned is [Insert Specific Rate/Formula, e.g., 1 point per $1 paid
                on the principal portion of the car loan].
              </p>

              <h3>Redemption</h3>
              <p>
                Rewards may be redeemed for [List all options: Travel, cash back, vehicle maintenance credits, etc.] subject
                to the specific redemption rules outlined in the Lucid Black Rewards Program Agreement (a separate document).
              </p>

              <h3>Program Changes</h3>
              <p>
                Lucid Black reserves the right to modify, suspend, or terminate the Rewards Program, the Rewards structure,
                or these Terms at any time, with or without notice, subject to applicable law.
              </p>
            </section>

            <section className="terms-section">
              <h2>3. Cardholder Agreement and Eligibility</h2>
              <p>The issuance and use of the Lucid Black Card are governed by a separate, legally binding Cardholder Agreement.</p>

              <h3>Financial Terms</h3>
              <p>
                Your Cardholder Agreement will detail the Card's Annual Percentage Rate (APR), fees, minimum payment requirements,
                credit limit, and late payment penalties. In case of any conflict between these Terms and the Cardholder Agreement,
                the Cardholder Agreement will govern.
              </p>

              <h3>Eligibility</h3>
              <p>
                To be eligible to apply for the Card, you must be a resident of [List all states/regions where the card is offered]
                and meet specific creditworthiness and eligibility requirements as determined by Lucid Black and its financial partners.
              </p>
            </section>

            <section className="terms-section">
              <h2>4. Intellectual Property Rights</h2>
              <p>
                The content, features, and functionality of the Site and the Lucid Black brand, including the name "Lucid Black"
                and the lucidblack.io domain, are and will remain the exclusive property of [Your Company Legal Name] and its
                licensors. They are protected by copyright, trademark, and other laws of both the United States and foreign countries.
                Your use of the Card or Site grants you no right or license to reproduce or otherwise use any Lucid Black trademarks.
              </p>
            </section>

            <section className="terms-section">
              <h2>5. Limitation of Liability</h2>
              <p>
                In no event shall Lucid Black, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable
                for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of
                profits, data, use, goodwill, or other intangible losses, resulting from:
              </p>
              <ul>
                <li>(i) Your access to or use of or inability to access or use the Card or Site.</li>
                <li>(ii) Any conduct or content of any third party on the Site.</li>
                <li>(iii) Any content obtained from the Site.</li>
                <li>
                  (iv) Unauthorized access, use, or alteration of your transmissions or content, whether based on warranty,
                  contract, tort (including negligence), or any other legal theory, and whether or not we have been informed
                  of the possibility of such damage.
                </li>
              </ul>
            </section>

            <section className="terms-section">
              <h2>6. Governing Law and Dispute Resolution</h2>
              <p>
                These Terms shall be governed and construed in accordance with the laws of the State of [Insert State of Company
                Incorporation, e.g., Delaware], without regard to its conflict of law provisions.
              </p>

              <h3>Mandatory Arbitration</h3>
              <p>
                Any claim or dispute arising out of or relating to these Terms or the Card will be resolved by binding arbitration
                in [Insert City/County], [Insert State], rather than in court, unless otherwise provided in the Cardholder Agreement.
              </p>
            </section>

            <section className="terms-section">
              <h2>7. Changes to Terms</h2>
              <p>
                We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material,
                we will try to provide at least [Insert Number, e.g., 30] days' notice prior to any new terms taking effect. By
                continuing to access or use our Card or Site after those revisions become effective, you agree to be bound by the
                revised terms.
              </p>
            </section>
          </div>
        </div>
      </div>

      <footer className="terms-footer">
        <div className="container">
          <p>&copy; 2026 LucidBlack. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}

export default Terms;
